import React from 'react';

import { Text } from 'apps/auth/components/common/Text/Text';
import { BankLogoContainer, CardContainer, CardNumberBlock, CardRow, LogoPaysystem } from 'apps/auth/components/form/styles';
import { URL_IMAGES_PAYSYSTEMS } from 'apps/auth/constants/UrlConstants';
import { getBankAlias, isCardExpired } from 'apps/auth/helpers/utils';

interface CardInfo {
    pan?: string;
    alias?: string;
    cardLogo?: string;
    cardExpired?: string;
    paymentSystem?: string;
    [key: string]: unknown;
}

interface CardViewProps {
    card: CardInfo;
    cardExpDateMessage?: string;
}

const CardView: React.FC<CardViewProps> = ({ card, cardExpDateMessage }) => {
    const clearCardPan = card.pan?.replace(/\s/g, '');
    const expired = isCardExpired(card);

    return (
        <CardContainer>
            <div>
                <CardRow>
                    <BankLogoContainer>{getBankAlias(card.cardLogo, 'card', expired)}</BankLogoContainer>
                    {card.alias && (
                        <Text ellipsis color={expired ? 'lightGray' : 'primary'}>
                            {card.alias}
                        </Text>
                    )}
                </CardRow>
            </div>
            <div>
                <CardRow $readOnly $betweenJustify>
                    <CardNumberBlock $isCardExpired={expired}>{clearCardPan?.slice(0, 4)}</CardNumberBlock>
                    <CardNumberBlock $isCardExpired={expired}>{clearCardPan?.slice(4, 8)}</CardNumberBlock>
                    <CardNumberBlock $isCardExpired={expired}>{clearCardPan?.slice(8, 12)}</CardNumberBlock>
                    <CardNumberBlock $isCardExpired={expired}>{clearCardPan?.slice(12)}</CardNumberBlock>
                </CardRow>
                <CardRow $betweenJustify>
                    <div>
                        <Text variant="div" size="subheader" color={expired ? 'lightGray' : 'secondary'}>
                            {cardExpDateMessage}&nbsp;
                            {card.cardExpired}
                        </Text>
                    </div>
                    <LogoPaysystem $isCardExpired={expired}>
                        {card.paymentSystem && card.paymentSystem.length > 0 && card.paymentSystem !== 'other' && (
                            <img src={`${URL_IMAGES_PAYSYSTEMS}/${card.paymentSystem}.svg`} alt={card.paymentSystem} />
                        )}
                    </LogoPaysystem>
                </CardRow>
            </div>
        </CardContainer>
    );
};

export default CardView;
